/*
  "Add to bag" on single-variant best seller cards (snippets/best-sellers-card.liquid),
  and on the product rows of the homepage video tutorials
  (snippets/video-tutorials-product.liquid), which use the same data attributes.

  Posts the card's product form to /cart/add.js instead of leaving the page.
  The Unicorn cart app watches that endpoint and opens its drawer by itself,
  so this only reports progress on the button and keeps the theme in step the
  way theme.js does after its own add: it updates the header bag count and
  fires cart:updated with the new cart. Without JavaScript the form posts to
  /cart/add as normal.

  "Choose shade" needs nothing here; theme.min.js opens the quick view (see
  snippets/best-sellers.liquid). Listeners are delegated, so cards the theme
  editor re-renders keep working, and the guard stops a second copy of this
  script from adding a second listener.
*/
(function () {
  if (window.chellaBestSellersReady) return;
  window.chellaBestSellersReady = true;

  const ADDED_MS = 2500;
  const FALLBACK_ERROR = 'Sorry, this could not be added to your bag. Please try again.';

  function setStatus(form, message, isError) {
    const status = form.querySelector('[data-best-sellers-status]');
    if (!status) return;
    status.classList.toggle('is-error', Boolean(isError));
    status.textContent = message;
  }

  function readJson(response) {
    return response.json().then(
      function (body) {
        return { ok: response.ok, body: body };
      },
      function () {
        return { ok: false, body: {} };
      }
    );
  }

  document.addEventListener('submit', function (event) {
    const form = event.target.closest ? event.target.closest('form[data-best-sellers-add]') : null;
    if (!form || !window.fetch) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const label = form.querySelector('[data-best-sellers-label]');
    if (!button || !label || button.classList.contains('loading')) return;

    // Read once: a second add during the "Added" confirmation must not
    // capture the confirmation as the label to go back to.
    if (!label.hasAttribute('data-idle-label')) label.setAttribute('data-idle-label', label.textContent);
    const idleText = label.getAttribute('data-idle-label');
    window.clearTimeout(Number(button.getAttribute('data-reset-timer')));
    const title = (document.getElementById(button.getAttribute('aria-describedby')) || {}).textContent || '';
    // Shopify's own reason ("only 2 left") is worth showing; a network
    // TypeError ("Failed to fetch") is not.
    let cartError = '';
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    setStatus(form, '', false);

    fetch(form.action + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
    })
      .then(readJson)
      .then(function (added) {
        if (!added.ok) {
          cartError = added.body.description || added.body.message || '';
          throw new Error(cartError);
        }
        // The item is in the bag by now, so a failed refresh only skips the
        // count update; it must not report the add as failed.
        return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }).then(readJson, function () {
          return { ok: false, body: {} };
        });
      })
      .then(function (cart) {
        if (cart.ok && typeof cart.body.item_count === 'number') {
          document.querySelectorAll('[data-js-cart-count]').forEach(function (count) {
            count.textContent = cart.body.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart.body } }));
        }

        label.textContent = button.getAttribute('data-added-label') || idleText;
        setStatus(form, (title.trim() + ' added to your bag').trim(), false);
        const timer = window.setTimeout(function () {
          label.textContent = idleText;
        }, ADDED_MS);
        button.setAttribute('data-reset-timer', String(timer));
      })
      .catch(function () {
        setStatus(form, cartError || FALLBACK_ERROR, true);
      })
      .finally(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  });
})();
